import { render, staticRenderFns } from "./BayAssignedWorkersModal.vue?vue&type=template&id=ba7c5bdc&scoped=true"
import script from "./BayAssignedWorkersModal.vue?vue&type=script&lang=js"
export * from "./BayAssignedWorkersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7c5bdc",
  null
  
)

export default component.exports